import { render, staticRenderFns } from "./wenshuzhishen.vue?vue&type=template&id=4a9c2a56&scoped=true&lang=pug"
import script from "./wenshuzhishen.vue?vue&type=script&lang=ts"
export * from "./wenshuzhishen.vue?vue&type=script&lang=ts"
import style0 from "./wenshuzhishen.vue?vue&type=style&index=0&id=4a9c2a56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9c2a56",
  null
  
)

export default component.exports